import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { ActiveVehicleUsagesPage } from "@/features/vehicles/pages/active-vehicle-usages-page";
import { activeVehicleUsageFilterSchema } from "@/features/vehicles/schemas/active-vehicle-usage-filter.schema";

export const Route = createFileRoute(
	"/_authenticated/admin/vehicles/active-usages"
)({
	head: () => pageTitle("Active vehicle usages"),
	component: ActiveVehicleUsagesPage,
	validateSearch: zodValidator(activeVehicleUsageFilterSchema),
});
